/**
 * @file 报名选项
 */

import { faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import { Button, Ellipsis, Modal } from '@seiue/ui'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'
import { OptionReq } from 'packages/sdks-next/growp'

import { EditOpenContent } from '../EditOptionContent'

import { OptionPreview } from './OptionPreview'
import { getTheme } from '@/utils/theme'

/**
 * 选项合
 *
 * @param param - 参数
 * @param param.setOptions - 设置选项列表
 * @param param.options - 选项列表
 * @param param.option - 当前选项
 * @param param.optionIndex - 当前选项在列表的位置
 * @returns 组件
 */
export const OptionBox: React.FC<{
  setOptions: (op: OptionReq[]) => void
  options: OptionReq[]
  option: OptionReq
  optionIndex: number
}> = ({ setOptions, options, option, optionIndex }) => {
  const theme = getTheme()
  return (
    <Box>
      <HeaderBox>
        <Ellipsis text={option.name} />
        <VolumeBox>
          容量: {option.volume && option.volume > 0 ? option.volume : '不限制'}
        </VolumeBox>
      </HeaderBox>
      <BtnBox>
        <LeftBtnBox>
          <Button
            type="light-text"
            style={{ marginRight: 0, minWidth: 0 }}
            onClick={() => {
              const { hide } = Modal.open({
                width: 750,
                footer: null,
                bodyStyle: {
                  padding: '0',
                },
                title: '编辑报名选项',
                children: (
                  <EditOpenContent
                    hide={() => hide()}
                    setOptions={setOptions}
                    options={options}
                    option={option}
                    optionIndex={optionIndex}
                  />
                ),
              })
            }}
          >
            <GrowpIcon
              name="Edit"
              text="编辑"
              size={14}
              color={theme.text._3}
            />
          </Button>
          <Button
            type="light-text"
            style={{ marginRight: 0, minWidth: 0 }}
            onClick={() => {
              const copyOps = options.filter(
                (op) =>
                  op.name &&
                  op.name !== option?.name &&
                  op.name.search(option?.name || '') !== -1
              )
              const addOption = {
                ...option,
                id: undefined,
                name: `${option.name}` + '_副本'.repeat(copyOps.length + 1),
              }
              const newOptions = [addOption, ...options]
              setOptions([...newOptions])
            }}
          >
            <GrowpIcon
              name="Fuzhi"
              text="复制"
              size={14}
              color={theme.text._3}
            />
          </Button>
          <Button
            type="light-text"
            style={{ marginRight: 0, minWidth: 0 }}
            onClick={() => {
              options.splice(optionIndex, 1)
              setOptions([...options])
            }}
          >
            <GrowpIcon
              name="Shanchu"
              text="删除"
              size={14}
              color={theme.text._3}
            />
          </Button>
        </LeftBtnBox>
        <Button
          type="light-text"
          iconRight={faAngleRight}
          size={'xs'}
          style={{
            color: theme.brand._1,
            marginRight: 0,
            fontSize: 14,
            minWidth: 0,
          }}
          onClick={() => {
            Modal.open({
              width: 960,
              footer: null,
              bodyStyle: {
                padding: '0',
              },
              title: '选项详情',
              children: (
                <OptionPreview
                  title={option.name ?? ''}
                  content={option.description ?? ''}
                />
              ),
            })
          }}
        >
          详情
        </Button>
      </BtnBox>
    </Box>
  )
}

const Box = styled.div`
  border: 1px solid ${(props) => props.theme.border.greyNormal};
  width: 394px;
  height: 108px;
  border-radius: 8px;
  padding: 20px 20px 16px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const HeaderBox = styled.div`
  height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: ${(props) => props.theme.text._1};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`

const VolumeBox = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${(props) => props.theme.text._2};
  flex-shrink: 0;
  font-weight: 400;
`

const BtnBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const LeftBtnBox = styled.div`
  display: flex;
  gap: 12px;
`
